import { NFormTable } from "../../../Shared/NewForms/NFormTable";
import { NFLookupProduct } from "../../../Shared/NewForms/NFLookupProduct";
import { NFIntInput } from "../../../Shared/NewForms/NFIntInput";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { NFLookupAccount } from "../../../Shared/NewForms/NFLookupAccount";
import { NFLookupAccrual } from "../../../Shared/NewForms/NFLookupAccrual";

export const ProductionAndSalesDetailEmployeeEarnings = () => {
    const tableName = "products";
    const { t } = useTranslation();

    useEffect(() => {}, []);

    return (
        <>
            <NFormTable fieldArray={"employeeEarnings"}>
                <NFLookupProduct title={t("Job")} fieldName="jobId" />
                <NFLookupAccrual
                    title={t("Accrual Type")}
                    fieldName="accrualTypeId"
                />
                <NFIntInput title={t("Coefficient")} fieldName="coefficient" />
                <NFIntInput title={t("Amount")} fieldName="amount" />
                <NFIntInput title={t("NetAmount")} fieldName="netAmount" />
                <NFIntInput
                    title={t("PersonalContribution(Company)")}
                    fieldName="personalContributionCompany"
                />
                <NFIntInput
                    title={t("Personal Contribution (Employee)")}
                    fieldName="personalContributionEmployee"
                />
                <NFIntInput title={t("Income Tax")} fieldName="incomeTax" />
                <NFLookupAccount title={t("Account")} fieldName="accountId" />
            </NFormTable>
        </>
    );
};
